import React, {useEffect, useState} from "react";
import {Button, Icon, Position, Tooltip, Viewer, Worker} from "@react-pdf-viewer/core";
import {NextIcon, PreviousIcon, searchPlugin} from "@react-pdf-viewer/search";
import {pageNavigationPlugin,} from "@react-pdf-viewer/page-navigation";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/search/lib/styles/index.css";

const PDFViewer = ({currentRefinement, file, clickedText}) => {
    const searchPluginInstance = searchPlugin({
        onHighlightKeyword: (props) => {
            props.highlightEle.style.backgroundColor = 'yellow';
        },
    });
    const pageNavigationPluginInstance = pageNavigationPlugin();

    const {Search} = searchPluginInstance;


    const SearchComponent = renderSearchProps => {
        const {keyword, setKeyword, clearKeyword, search, currentMatch, numberOfMatches} = renderSearchProps;
        const [readyToSearch, setReadyToSearch] = useState(false);
        const delaySearchFeedback = () =>
            setTimeout(() => {
                setReadyToSearch(true);
            }, 1000);

        useEffect(() => {
            if (clickedText) {
                setKeyword(clickedText)
            } else {
                setKeyword('Sé que això no està bé, però és que la funcion clearKeyword() no està funcionant. No està netejant la cerca, els conceptes anterior segueixen subratllats. Fent aquest chapuza funciona.')
                // clearKeyword();
            }
        }, []);

        useEffect(() => {
            if ((keyword && (keyword === currentRefinement || keyword === clickedText)) || clickedText === null) {
                delaySearchFeedback();
                search();
            }
        }, [keyword]);

        return (
            <>
                <div
                    className="d-none px-1"
                    style={{
                        border: "1px solid rgba(0, 0, 0, 0.3)",
                    }}
                >
                    <input
                        className="search_input"
                        placeholder="Enter to search"
                        type="text"
                        value={keyword}
                        onChange={e => {
                            setReadyToSearch(false);
                            setKeyword(e.target.value);
                        }}
                        onKeyDown={e => {
                            if (e.code === 13 && keyword) {
                                delaySearchFeedback();
                                search();
                            }
                        }}
                    />

                </div>
                {/*{readyToSearch && keyword && numberOfMatches === 0 && <div className="px-3">Not found</div>}*/}
                {/*{readyToSearch && keyword && numberOfMatches > 0 && (*/}
                {/*    <div className="px-3">*/}
                {/*        {currentMatch} of {numberOfMatches}*/}
                {/*    </div>*/}
                {/*)}*/}
            </>
        );
    };

    return (
        <div className="d-flex flex-column h-100 rounded overflow-hidden">
            <div className="d-flex align-items-center border-bottom border-gray p-1 bg-light">
                <Search>{SearchComponent}</Search>
            </div>
            <div className="flex-1 overflow-hidden">
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.8.335/build/pdf.worker.min.js">
                    <Viewer fileUrl={file} plugins={[searchPluginInstance, pageNavigationPluginInstance]}/>
                </Worker>
            </div>
        </div>
    );
};

export default PDFViewer;
